import { Pipe, PipeTransform, Injectable  } from '@angular/core';

/**
 * Author: Sridhar Swaminathan
 * 
 * Date Created: August 10th 2018
 * 
 * Description: Component class to search/filter JSON Data 
 **/
@Pipe({
  name: 'search'
})


@Injectable()
export class SearchPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if(!value)return null;
    if(!args)return value;

    args = args.toLowerCase();

   return value.filter(function(item){
        return JSON.stringify(item).toLowerCase().includes(args);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/pipe/search.pipe.ts